



















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import MovieListItem from './MovieListItem.vue';
import Movie from '@/objects/movie';

@Component({
    components: {
        MovieListItem,
    },
})
export default class MovieList extends Vue {
    @Prop() movies!: Movie[];

    @Prop() isWatchlist!: boolean;

    get userMoviesCount() {
        const result = this.$store.getters.userMoviesCount;

        return result;
    }
}
